import Vue from 'vue'
import Router from 'vue-router'
import {Role} from '@/views/variables/roles'
import store from '@/store'

import admin from './modules/admin'
import app from './modules/app'

Vue.use(Router)

const loginPath = '/login'
const restorePath = '/restore-password'
const preChangePasswordPath = '/pre-change-password/:uuid'
const changePasswordPath = '/change-password'
const errorPath = '/error'

const baseRoutes = [
  {
    path: '/',
    name: 'Основной контейнер',
    component: () => import('@/views/layout/Main'),
    redirect: () =>
      store.state.auth.user
        ? store.state.auth.user.roles[0] == Role.Admin
          ? '/admin/community/list'
          : '/houses/list'
        : '/login',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: loginPath,
    name: 'login',
    component: () => import('@/views/pages/login/Login')
  },
  {
    path: preChangePasswordPath,
    name: 'PasswordChangeValidation',
    component: () => import('@/views/pages/password/reset/PasswordChangeValidation')
  },
  {
    path: changePasswordPath,
    name: 'passwordChange',
    component: () => import('@/views/pages/password/reset/PasswordChange')
  },
  {
    path: restorePath,
    name: 'passwordRestore',
    component: () => import('@/views/pages/password/restore/PasswordRestore')
  },
  {
    path: '*',
    name: 'notFound',
    component: () => import('@/views/pages/NotFound')
  },
  {
    path: errorPath,
    name: 'error',
    component: () => import('@/views/pages/Error')
  }
]

const routes = baseRoutes.concat(app, admin)

const router = new Router({
  mode: 'history',
  routes
})

function check() {
  return store
    .dispatch('auth/CHECK')
    .then(resp => {
      return resp.data
    })
    .catch(() => {
      return null
    })
}

router.beforeEach(async (to, from, next) => {
  const user = store.state.auth.user != null ? await check() : null
  if (to.path === restorePath) {
    return next()
  }

  if (to.name === 'PasswordChangeValidation') {
    return next()
  }

  if (user == null) {
    if (to.path === loginPath) {
      return next()
    } else {
      return next(loginPath)
    }
  }

  // noinspection JSUnresolvedVariable
  if (user.isNeedChangePassword) {
    if (to.path === changePasswordPath) {
      return next()
    } else {
      return next(changePasswordPath)
    }
  }

  const {authorize} = to.meta
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (to.matched.some(record => record.meta.authorize)) {
      // noinspection JSUnresolvedVariable
      if (authorize.length && authorize.includes(user.roles[0])) {
        return next()
      } else {
        return next(errorPath)
      }
    } else {
      return next()
    }
  }

  next()
})

// noinspection JSIgnoredPromiseFromCall
// router.replace('/');

export default router
